import React from 'react';

const TrainingLogs = ({ logs }) => {
  return (
    <div>
      <h3 className="font-semibold text-gray-800 mb-2">🧾 Training Logs</h3>
      <pre className="bg-gray-900 text-green-200 text-sm p-4 rounded-lg max-h-64 overflow-auto whitespace-pre-wrap shadow-inner">
        {logs || '⚠ No logs yet. Submit a task to see output.'}
      </pre>
    </div>
  );
};

export default TrainingLogs;
